import ForgotPasswordBody from "@/components/landing/auth/ForgotPasswordBody";

export default function ForgotPasswordPage() {
  return <ForgotPasswordBody />;
}
